import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 8px 8px 8px 16px;
  border: 1px solid #999;
  border-radius: 4px;
  min-height: 42px;
  position: relative;
  width: 100%;

  &:focus-within {
    border-color: ${({ theme }) => theme.brand.primary.base};
  }
`;

export const ComboboxTarget = styled.button`
  margin-left: auto;
  display: flex;
  align-items: center;
  position: absolute;
  top: 12px;
  right: 10px;

  &:focus-visible {
    // Focus is on the container.
    outline: none;
  }
`;

export const ListContainer = styled.div`
  // hardcoding widths here as usually we want the dropdown to be a specified width of min-width:200px i.e. in the menu dropdown
  width: 366px;
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: 380px;
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    width: 270px;
  }
`;
